import React from "react";

// Slim premium ticker — 32px desktop / 28px mobile
const ITEMS = [
    "FREE DESIGN CONSULTATION",
    "45-60 DAYS DELIVERY PLAN",
    "TRANSPARENT PRICING",
    "PREMIUM MATERIALS",
    "OFFICE • HOME • RETAIL",
    "ONE TEAM. ZERO HEADACHE.",
];

const Row = () => (
    <div className="flex shrink-0 items-center gap-8 pr-8">
        {ITEMS.map((t, i) => (
            <div key={i} className="flex items-center gap-8">
                <span className="text-[12px] sm:text-[13px] font-semibold tracking-[0.08em] text-black whitespace-nowrap">
                    {t}
                </span>
                <span className="text-black/50 text-[10px]">•</span>
            </div>
        ))}
    </div>
);

export default function MarqueeBar() {
    return (
        <div
            data-testid="marquee-bar"
            className="w-full overflow-hidden bg-[#CCFF00] border-b border-black/10"
            style={{ height: "32px" }}
        >
            <div className="marquee-track h-full items-center">
                <Row />
                <Row />
            </div>
        </div>
    );
}
